import {
  AnswerType,
  Demander,
  MultiplyingFactor,
} from "../../assets/data/Constants";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const tableListContractor: ITkFakeTableLineProps[] = [
  {
    keyword: "lineTitle",
    type: "lineTitle",
    lineTitle: labelids.labelid.LBLC060134_01,
  },
  {
    title: "請求者選択",
    keyword: "decisionDemanderKbn",
    type: "selectForm",
    selectPropsList: TkGetCodeList(Demander),
    disabled: true,
  },
  {
    keyword: "brank",
    type: "lineTitle",
  },
  {
    title: "共済契約者番号",
    keyword: "contractorNo",
    inputProps: { maxLength: 6 },
    disabled: true,
  },
  {
    title: "共済契約者名",
    keyword: "contractorName",
    disabled: true,
  },
  {
    title: "代表者",
    keyword: "directorName",
    type: "name",
    disabled: true,
  },
  {
    title: "職員氏名",
    keyword: "staffName",
    type: "name",
    disabled: true,
  },
  {
    title: "職員番号",
    keyword: "staffNo",
    inputProps: { maxLength: 5 },
    disabled: true,
  },
  {
    title: "退職（予定）年月日①",
    keyword: "retirePlanDay1",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date("2099/12/31"),
    disabled: true,
  },
  {
    title: "退職月の直前４月から退職月までの期間のならない月①",
    keyword: "unaccountedMonthsTotal1",
    type: "inputWithText",
    innerText: "月",
    showLine: true,
    inputProps: { maxLength: 2 },
    disabled: true,
  },
  {
    title: "退職月の直近６ヶ月の平均俸給①",
    keyword: "sixMonthSalaryAverage1",
    type: "amount",
    inputProps: { maxLength: 9 },
    disabled: true,
  },
  {
    title: "退職（予定）年月日②",
    keyword: "retirePlanDay2",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date("2099/12/31"),
    disabled: true,
  },
  {
    title: "退職月の直前４月から退職月までの期間のならない月②",
    keyword: "unaccountedMonthsTotal2",
    type: "inputWithText",
    innerText: "月",
    showLine: true,
    inputProps: { maxLength: 2 },
    disabled: true,
  },
  {
    title: "退職月の直近６ヶ月の平均俸給②",
    keyword: "sixMonthSalaryAverage2",
    type: "amount",
    inputProps: { maxLength: 9 },
    disabled: true,
  },
  {
    title: "依頼理由",
    keyword: "requestReason",
    inputProps: { maxLength: 85 },
    disabled: true,
  },
  {
    title: "担当者氏名",
    keyword: "demanderName",
    type: "name",
    disabled: true,
  },
  {
    title: "担当者電話番号",
    keyword: "contractorTel",
    type: "phoneNum",
    disabled: true,
  },
  {
    title: "仮退職年月日以前６ヶ月の給与台帳（写）",
    keyword: "downloadLink1",
    type: "downloadLink",
    id: "1",
    disabled: false,
  },
];

const tableListStaff: ITkFakeTableLineProps[] = [
  {
    keyword: "lineTitle",
    type: "lineTitle",
    lineTitle: labelids.labelid.LBLC060134_01,
  },
  {
    title: "請求者選択",
    keyword: "decisionDemanderKbn",
    type: "selectForm",
    selectPropsList: TkGetCodeList(Demander),
    disabled: true,
  },
  {
    keyword: "brank",
    type: "lineTitle",
  },
  {
    title: "共済契約者名",
    keyword: "contractorName",
    disabled: true,
  },
  {
    title: "施設名",
    keyword: "facilityName",
    inputProps: { maxLength: 20 },
    disabled: true,
  },
  {
    title: "職員氏名",
    keyword: "staffName",
    type: "name",
    disabled: true,
  },
  {
    title: "職員生年月日",
    keyword: "staffBirthday",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date(),
    disabled: true,
  },
  {
    title: "職員住所郵便番号",
    keyword: "zipcode",
    type: "addressSearch",
    disabled: true,
  },
  {
    title: "職員住所(都道府県)",
    keyword: "prefectureCd",
    type: "locationGroup",
    disabled: true,
  },
  {
    title: "職員住所(市区町村)",
    keyword: "addressCity",
    disabled: true,
  },
  {
    title: "職員住所(その他)",
    keyword: "addressOthers",
    disabled: true,
  },
  {
    title: "退職（予定）年月日①",
    keyword: "retirePlanDay1",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date("2099/12/31"),
    disabled: true,
  },
  {
    title: "退職月の直近６ヶ月の平均俸給①",
    keyword: "sixMonthSalaryAverage1",
    type: "amount",
    inputProps: { maxLength: 9 },
    disabled: true,
  },
  {
    title: "退職（予定）年月日②",
    keyword: "retirePlanDay2",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date("2099/12/31"),
    disabled: true,
  },
  {
    title: "退職月の直近６ヶ月の平均俸給②",
    keyword: "sixMonthSalaryAverage2",
    type: "amount",
    inputProps: { maxLength: 9 },
    disabled: true,
  },
  {
    title: "依頼理由",
    keyword: "requestReason",
    inputProps: { maxLength: 85 },
    disabled: true,
  },
  {
    title: "身分証明書（写）",
    keyword: "downloadLink2",
    type: "downloadLink",
    id: "2",
    disabled: false,
  },
];

const tableListLawyer: ITkFakeTableLineProps[] = [
  {
    keyword: "lineTitle",
    type: "lineTitle",
    lineTitle: labelids.labelid.LBLC060134_01,
  },
  {
    title: "請求者選択",
    keyword: "decisionDemanderKbn",
    type: "selectForm",
    selectPropsList: TkGetCodeList(Demander),
    disabled: true,
  },
  {
    keyword: "brank",
    type: "lineTitle",
  },
  {
    title: "共済契約者名",
    keyword: "contractorName",
    disabled: true,
  },
  {
    title: "施設名",
    keyword: "facilityName",
    inputProps: { maxLength: 20 },
    disabled: true,
  },
  {
    title: "所属弁護士会名",
    keyword: "lawyerName",
    inputProps: { maxLength: 85 },
    disabled: true,
  },
  {
    title: "所属弁護士会　登録番号",
    keyword: "barAssociationRegistNo",
    inputProps: { maxLength: 60 },
    disabled: true,
  },
  {
    title: "送付先電話番号",
    keyword: "deliveryTel",
    type: "phoneNum",
    disabled: true,
  },
  {
    title: "送付先郵便番号",
    keyword: "deliveryZipcode",
    type: "addressSearch",
    disabled: true,
  },
  {
    title: "送付先住所(都道府県)",
    keyword: "deliveryPrefecture",
    type: "locationGroup",
    disabled: true,
  },
  {
    title: "送付先住所(市区町村)",
    keyword: "deliveryAddressCity",
    disabled: true,
  },
  {
    title: "送付先住所(その他)",
    keyword: "deliveryAddressOthers",
    disabled: true,
  },
  {
    title: "職員氏名",
    keyword: "staffName",
    type: "name",
    disabled: true,
  },
  {
    title: "職員生年月日",
    keyword: "staffBirthday",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date(),
    disabled: true,
  },
  {
    title: "職員住所郵便番号",
    keyword: "zipcode",
    type: "addressSearch",
    disabled: true,
  },
  {
    title: "職員住所(都道府県)",
    keyword: "prefectureCd",
    type: "locationGroup",
    disabled: true,
  },
  {
    title: "職員住所(市区町村)",
    keyword: "addressCity",
    disabled: true,
  },
  {
    title: "職員住所(その他)",
    keyword: "addressOthers",
    disabled: true,
  },
  {
    title: "退職（予定）年月日①",
    keyword: "retirePlanDay1",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date("2099/12/31"),
    disabled: true,
  },
  {
    title: "退職月の直近６ヶ月の平均俸給①",
    keyword: "sixMonthSalaryAverage1",
    type: "amount",
    inputProps: { maxLength: 9 },
    disabled: true,
  },
  {
    title: "退職（予定）年月日②",
    keyword: "retirePlanDay2",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date("2099/12/31"),
    disabled: true,
  },
  {
    title: "退職月の直近６ヶ月の平均俸給②",
    keyword: "sixMonthSalaryAverage2",
    type: "amount",
    inputProps: { maxLength: 9 },
    disabled: true,
  },
  {
    title: "依頼理由",
    keyword: "requestReason",
    inputProps: { maxLength: 85 },
    disabled: true,
  },
  {
    title: "仮退職年月日以前６ヶ月の給与台帳（写）",
    keyword: "downloadLink1",
    type: "downloadLink",
    id: "1",
    disabled: false,
  },
  {
    title: "委任状",
    keyword: "downloadLink2",
    type: "downloadLink",
    id: "2",
    disabled: false,
  },
];

const tableListAnswer: ITkFakeTableLineProps[] = [
  {
    keyword: "brank",
    type: "lineTitle",
  },
  {
    title: "回答種類",
    keyword: "answerPossibilityFlg",
    type: "radio",
    radioPropsList: TkGetCodeList(AnswerType),
    showLine: false,
  },
  {
    title: "被共済職員氏名",
    keyword: "answerStaffName",
    type: "name",
    showLine: false,
    disabled: true,
  },
  {
    title: "生年月日",
    keyword: "answerBirthday",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date("2099/12/31"),
    showLine: false,
    disabled: true,
  },
  {
    title: "勤務先",
    keyword: "workPlace",
    inputProps: { maxLength: 85 },
    showLine: false,
    disabled: true,
  },
  {
    title: "退職手当金見込額①",
    keyword: "retirementAllowanceExpectAmt1",
    type: "amount",
    inputProps: { maxLength: 9 },
    showLine: false,
    disabled: true,
  },
  {
    title: "制度加入年月日①",
    keyword: "firstJoinDate1",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date("2099/12/31"),
    showLine: false,
    disabled: true,
  },
  {
    title: "仮退職年月日①",
    keyword: "tentativeRetireDate1",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date("2099/12/31"),
    showLine: false,
    disabled: true,
  },
  {
    title: "被共済職員期間①",
    keyword: "maePeriod1",
    type: "nodeInLine",
    showLine: false,
    disabled: true,
  },
  {
    title: "支給乗率①",
    keyword: "paymentMultiplierKbn1",
    type: "selectForm",
    selectPropsList: TkGetCodeList(MultiplyingFactor),
    showLine: false,
  },
  {
    title: "退職手当金見込額②",
    keyword: "retirementAllowanceExpectAmt2",
    type: "amount",
    inputProps: { maxLength: 9 },
    showLine: false,
    disabled: true,
  },
  {
    title: "制度改正加入年月日②",
    keyword: "firstJoinDate2",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date("2099/12/31"),
    showLine: false,
    disabled: true,
  },
  {
    title: "仮退職年月日②",
    keyword: "tentativeRetireDate2",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date("2099/12/31"),
    showLine: false,
    disabled: true,
  },
  {
    title: "被共済職員期間②",
    keyword: "maePeriod2",
    type: "nodeInLine",
    showLine: false,
    disabled: true,
  },
  {
    title: "支給乗率②",
    keyword: "paymentMultiplierKbn2",
    type: "selectForm",
    selectPropsList: TkGetCodeList(MultiplyingFactor),
    showLine: false,
  },
];

const canNotTableListAnswer: ITkFakeTableLineProps[] = [
  {
    keyword: "brank",
    type: "lineTitle",
  },
  {
    title: "回答種類",
    keyword: "answerPossibilityFlg",
    type: "radio",
    radioPropsList: TkGetCodeList(AnswerType),
    showLine: false,
  },
  {
    title: "被共済職員氏名",
    keyword: "answerStaffName",
    type: "name",
    showLine: false,
    disabled: true,
  },
  {
    title: "生年月日",
    keyword: "answerBirthday",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date("2099/12/31"),
    showLine: false,
    disabled: true,
  },
  {
    title: "勤務先",
    keyword: "workPlace",
    inputProps: { maxLength: 85 },
    showLine: false,
    disabled: true,
  },
  {
    title: "回答不可理由",
    keyword: "noAnswerReason",
    inputProps: { maxLength: 85 },
    showLine: false,
  },
];

const schema = {
  answerPossibilityFlg: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  workPlace: {
    pattern: {
      value: /^[^ -~｡-ﾟ]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  noAnswerReason: {
    pattern: {
      value: /^[^ -~｡-ﾟ]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
};

const headList: any[] = [
  {
    headTitle: "決裁日",
    align: "left",
  },
  {
    headTitle: "記号番号",
    align: "left",
  },
];

export {
  tableListContractor,
  tableListStaff,
  tableListLawyer,
  tableListAnswer,
  schema,
  headList,
  canNotTableListAnswer,
};
